import DefaultFormat from './default_format.helper'
import { datesAreOnSameDayOrAfter, verifyNum } from '../style_string.helper'

export default class SandraMoraFormat extends DefaultFormat {
  formatDateCSV () {
    let { date } = this.jsonObj
    date = date.split(/\D/)
    let d, m, y
    if (date[0].length === 4) {
      y = date[0]
      m = date[1]
      d = date[2]
    } else {
      d = date[0]
      m = date[1]
      y = date[2]
    }
    // let [y, m, d] = date
    if (d.length === 1 && Number(d) < 10) d = `0${d}`
    if (y.length !== 2) y = y.slice(2)
    date = `${d}/${m}/${y}` // Format date to DD/MM/YY
    if (date.length !== 8) throw new Error(`La fecha de la cita con numero ${this.jsonObj.number} no es válida. El formato debe ser DD/MM/YY.`)

    const today = new Date()
    const dateToCheck = new Date(y, m - 1, d)
    dateToCheck.setFullYear(dateToCheck.getFullYear() + 100) // So that the year is not 1900
    if (isNaN(dateToCheck)) throw new Error(`La fecha de la cita con numero ${this.jsonObj.number} no es válida.`)
    if (!datesAreOnSameDayOrAfter(today, dateToCheck)) throw new Error(`La fecha de la cita con numero ${this.jsonObj.number} no puede ser en el pasado.`)
    return `${d}/${m}/${dateToCheck.getFullYear()}`
  }

  async formatNumberCSV () {
    try {
      const { number, observation, status, doctor } = this.jsonObj

      // If the observation includes 'no conf', return empty string
      if (observation?.toLowerCase().includes('no conf') ||
        status?.toLowerCase().includes('cancelada') ||
        !doctor?.toLowerCase().includes('sandra mora')
      ) return ''

      if (number === undefined) {
        throw new Error(`El usuario ${this.jsonObj.name} tiene un número inválido.`)
      }
      const numberArr = number
        .replace(/\s+/g, ' ')
        .split('-')
        .map(n => n.replace(/\D/g, ''))
      // Get the number with the most digits
      const n = numberArr.reduce((max, n) => n.length > max.length ? n : max, '')
      return await verifyNum(n, this.jsonObj)
    } catch (error) {
      if (error?.response?.data !== null && parseInt(error?.response?.data.errors[0].code) === 21) {
        throw new Error(`El usuario ${this.jsonObj.name} tiene un número inválido.`)
      }
      throw new Error(error.message)
    }
  }

  formatTimeCSV () {
    const { date } = this.jsonObj
    // Sanitize and split the date string, ignore unused variable 'd'
    const [, t] = date
      .trim()
      .replaceAll('.', '') // Remove dots
      .replace(/\s+/g, ' ') // Replace multiple spaces with one
      .replace(/(?:\\[rn]|[\r\n])/g, '') // Remove new lines
      .split(' ')
    const aux = t.length >= 7 ? t.slice(0, -3) : t
    // Convert military time (24-hour) to 12-hour format
    const [hourStr, minuteStr] = aux.split(':')
    let hour = parseInt(hourStr, 10)
    const minute = minuteStr || '00'
    // Determine AM/PM based on the hour value
    let ampm = 'AM'
    if (hour === 0) {
      hour = 12
      ampm = 'AM'
    } else if (hour === 12) {
      ampm = 'PM'
    } else if (hour > 12) {
      hour = hour - 12
      ampm = 'PM'
    }
    const time = `${hour}:${minute} ${ampm}`

    return time
  }

  formatType () {
    const rawType = this.jsonObj?.type
    const typeStr = rawType === undefined || rawType === null ? '' : String(rawType).trim()
    if (!typeStr) {
      const ref = this.jsonObj?.number ? ` (cita #${this.jsonObj.number})` : ''
      const name = this.jsonObj?.name ? ` para ${this.jsonObj.name}${ref}` : ref
      throw new Error(`Falta el campo "Entidad" (tipo de cita) ${name}. Revisa el CSV: debe incluir la columna "Entidad".`)
    }
    if (typeStr.toLowerCase().includes('suramericana')) return 'Poliza de Sura'
    return 'Particular'
  }

  formatFinalObj (obj) {
    // Sandra Mora confirmations require "type" to be present; fail fast if missing.
    obj.type = this.formatType()
    return obj
  }
}
